import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { BehaviorSubject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { AuthService } from "src/app/core/service/auth.service";
import { RecurrenceSubscriptionFilterDTO } from "src/app/data/schema/Billing/Filter/RecurrenceSubscriptionFilterDTO";
import { RecurrenceSubscriptionDTO } from "src/app/data/schema/Billing/RecurrenceSubscription/RecurrenceSubscriptionDTO";
import { SubscriptionStatusDTO } from "src/app/data/schema/Billing/RecurrenceSubscription/SubscriptionStatusDTO";
import { ApiBillingRecurrenceSubscriptionService } from "src/app/data/service/billing/api-billing-recurrence-subscription.service";
import { CancelRecurrenceSubscriptionComponent } from "./components/cancel-recurrence-subscription/cancel-recurrence-subscription.component";

@Component({
    selector: "app-profile-recurrence-subscriptions",
    templateUrl: "./profile-recurrence-subscriptions.component.html",
    styleUrls: ["./profile-recurrence-subscriptions.component.scss"]
})
export class ProfileRecurrenceSubscriptionsComponent implements OnInit {
    loading = true;
    showMore = true;

    query = {
        skip: 0,
        take: 10,
        status: [],
        userId: null
    } as RecurrenceSubscriptionFilterDTO;

    status$ = new BehaviorSubject<Array<SubscriptionStatusDTO>>([]);
    bills$ = new BehaviorSubject<Array<RecurrenceSubscriptionDTO>>([]);

    constructor(
        private _apiBillingRecurrenceSubscriptionService: ApiBillingRecurrenceSubscriptionService,
        private authService: AuthService,
        private _matDialog: MatDialog
    ) {
        this.query;
    }

    ngOnInit(): void {
        this.status$.pipe(debounceTime(1500), distinctUntilChanged()).subscribe((status) => {
            this.query.skip = 0;
            this.query.status = status;
            this.bills$.next([]);
            this.load();
        });
    }

    private load(): void {
        this.loading = true;
        this._apiBillingRecurrenceSubscriptionService
            .list({
                find: this.query.find,
                planIds: this.query.planIds,
                status: this.query.status,
                orderBy: this.query.orderBy,
                sortOrder: this.query.sortOrder,
                skip: this.query.skip,
                take: this.query.take,
                active: null,
                userId: this.authService.getClaimsUserId()
            })
            .subscribe((bills) => {
                const temp = this.bills$.getValue();
                temp.push(...bills.data);
                this.bills$.next(temp);

                this.showMore = bills.totalRows > this.bills$.getValue().length;

                this.loading = false;
            });
    }

    public loadMore(): void {
        this.query.skip += this.query.take;
        this.load();
    }

    getPaymentMethodAlias(paymentMethodCode: string): string {
        switch (paymentMethodCode) {
            case "CreditCard":
                return "RECURRENCE_SUBSCRIPTION.PAYMENT_METHOD_CODE.CREDIT_CARD";
            case "BankSlip":
                return "RECURRENCE_SUBSCRIPTION.PAYMENT_METHOD_CODE.BANK_SLIP";
            case "Pix":
                return "RECURRENCE_SUBSCRIPTION.PAYMENT_METHOD_CODE.PIX";
            default:
                return paymentMethodCode;
        }
    }

    openCancelBillDialog(bill: RecurrenceSubscriptionDTO): void {
        const dialogRef = this._matDialog.open(CancelRecurrenceSubscriptionComponent, {
            data: {
                bill: bill
            },
            maxHeight: "100vh",
            maxWidth: "100vw"
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                this.bills$.next([]);
                this.load();
            }
        });
    }
}
